'use client';

import { motion, useReducedMotion } from 'framer-motion';

interface FadeInProps {
  delay?: number;
  children: React.ReactNode;
  className?: string;
}

export default function FadeIn({ delay = 0, children, className }: FadeInProps) {
  const reducedMotion = useReducedMotion();
  return (
    <motion.div
      initial={reducedMotion ? false : { opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
